export default {
  path: '/',
  name: 'Pages',
  component: () => import('../components/Layout'),
  redirect: { name: 'Home' },
  children: [
    {
      name: 'Home',
      path: '',
      component: () => import('../views/Home')
    }
  ]
}
